<div class="warp-data-summary">
  <img class="imgType" src="/assets/images/types/{{ questionData?.question?.type?.image }}" />
  <div class="warp-data-question">
    <div class="warp-title-question">
      <div>
        <div class="data-question">
          {{ questionData?.question | questionTitle }}
        </div>
        <div class="comments" *ngIf="filterRecipients$()== undefined">
          <p>{{ questionData?.comments }}</p>
          <p translate>data.comments</p>
        </div>
      </div>
      <div *ngIf="questionData?.question?.toNum && filterRecipients$()== undefined" class="export pointer" (click)="export()">
        <span translate>data.export.title</span>
        <span *ngIf="showComparison$()" >(</span>
        <span *ngIf="showComparison$()" translate>data.export.includeComparison</span>
        <span *ngIf="showComparison$()" >)</span>
      </div>
    </div>
    <ng-container *ngFor="let r of recipients">
      <que-answer-group-to-recipient [recipient]="r" [questionData]="questionData"></que-answer-group-to-recipient>
    </ng-container>
  </div>
</div>